import { AssertionError } from "./AssertionError.js";

export function raise(message: string | Error): never {
	if (typeof message === "string") {
		throw new AssertionError(message);
	}
	throw message;
}
